module.exports = __webpack_public_path__ + "static/media/auth_background.ade750ee.png";